import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';

@Component({
  selector: 'ui-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ButtonComponent {
  @Input() addClass!: string;
  @Input() buttonText!: string;
  @Input() rank:
    | 'primary'
    | 'alt-primary'
    | 'secondary'
    | 'alt-secondary'
    | 'light'
    | 'link' = 'primary';
  @Input() alertStatus?: 'success' | 'danger' | 'warning' | 'info';
  @Input() size?: 'small' | 'large';
  @Input() buttonType: 'button' | 'submit' = 'button';
  @Input() buttonDisabled = false;
  @Input() minWidth = 128;
  @Input() iconLeft?: 'add_circle_outline' | string;

  /**
   * Material glyph rendered AFTER the label — for controls whose icon points at
   * what the button leads to (a `chevron`/`arrow_forward_ios` affordance), and
   * for any button the design draws with a trailing glyph (Orbi's Mobile
   * Check-in, PCSA-13576). `iconLeft` is not a substitute in either case: the
   * side is either the meaning or the spec.
   */
  @Input() iconRight?: string;

  /**
   * Accessible name, when the visible label is not distinguishing on its own —
   * several "View" buttons on one screen each need to say what they view. Falls
   * back to `buttonText` (the visible label) when unset, which is the correct
   * name for every other button and keeps existing usages unchanged.
   */
  @Input() ariaLabel?: string;
  @Input() inProgress = false;
  @Input() link?: string;
  @Input() useRouterLink = false;
  @Input() queryParams = {};
  @Input() fullWidth = false;
  @Output() handleClick: EventEmitter<void> = new EventEmitter();

  onClick() {
    if (!this.buttonDisabled) {
      this.handleClick.emit();
    }
  }
}
